export enum EntityType {
  DEALER = 'dealer',
  IMPORTER = 'importer',
  COMPANY = 'company'
}
